import {
  IonCard,
  IonCardContent,
  IonCol,
  IonGrid,
  IonIcon,
  IonRow,
} from '@ionic/react';
import { bulbOutline } from 'ionicons/icons';
import { ReactElement } from 'react';
import './information-button.css';

interface InformationButtonProps {
  icon?: string;
  displayIcon?: boolean;
  message: string;
  onClick: () => void;
}

/**
 * The InformationButton component is a button that may contain more text than a
 * standard button.
 */
const InformationButton = (props: InformationButtonProps): ReactElement => {
  const { message, onClick, displayIcon = true, icon = bulbOutline } = props;

  return (
    <IonCard className="information-button" onClick={onClick} button>
      <IonCardContent>
        <IonGrid className="ion-no-padding">
          <IonRow className="ion-align-items-center">
            {displayIcon && (
              <IonCol className="icon-container">
                <IonIcon icon={icon} size="small" />
              </IonCol>
            )}
            <IonCol>{message}</IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  );
};

export { InformationButton };
